import * as HLF from "html-living-framework";
import {Application} from "../Application";
import {Callback} from "../core/Reflection";
import {VoiceOverManager} from "../managers/VoiceOverManager";

export class VOWatcher {

    public readonly vo: string;
    public readonly extraSeconds: number;
    public readonly onStart: Callback;
    public readonly onEnd: Callback;

    private _interval?: number;

    constructor(vo: string, extraSeconds: number, onStart: Callback, onEnd: Callback) {
        this.vo = vo;
        this.extraSeconds = extraSeconds;
        this.onStart = onStart;
        this.onEnd = onEnd;
    }

    public start() {
        if (!VoiceOverManager.instance.active) {
            return;
        }
        let extraSeconds = this.extraSeconds;
        this.onStart();
        this.destroy();
        this._interval = window.setInterval(() => {
            const track = Application.instance.audio.getAudioTrack(this.vo, HLF.AudioCategory.VO);
            if (!track || !track.isPlaying()) {
                if (extraSeconds > 0) {
                    extraSeconds--;
                } else {
                    window.clearInterval(this._interval);
                    this.onEnd();
                }
            }
        }, 1000);
    }

    public destroy() {
        if (this._interval) {
            window.clearInterval(this._interval);
            this._interval = undefined;
        }
    }
}
